import React, { useState } from "react";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";

import Home from "./pages/Home/Home";
import Dictionary from "./pages/Dictionary/Dictionary";
import Scraps from "./pages/Scraps/Scraps";
import Auth from "./pages/Auth/Auth";
import About from "./pages/About/About";
import Activity from "./pages/Activity/Activity";
import NodeDetails from "./pages/NodeDetails/NodeDetails";

import Sidebar from "./components/Sidebar";
import UserInfo from "./components/UserInfo";

const AppRoutes: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <BrowserRouter>
      <Sidebar isOpen={sidebarOpen} />
      <header>
        {/* Logo, site title, etc. */}
        <nav>
          <NavLink className="nav-link" to="/" end>Home</NavLink>
          <NavLink className="nav-link" to="/dictionary">Dictionary</NavLink>
          <NavLink className="nav-link" to="/activity">Activity</NavLink>
          <NavLink className="nav-link" to="/auth">Auth</NavLink>
          <NavLink className="nav-link" to="/about">About</NavLink>
          <NavLink className="nav-link" to="/scraps">Scraps</NavLink>
          <span className="nav-spacer" />
          <UserInfo />
          <button
            className={`nav-link hamburger${sidebarOpen ? " active" : ""}`}
            onClick={() => setSidebarOpen((open) => !open)}
            aria-label={sidebarOpen ? "Close sidebar" : "Open sidebar"}
          >
            {sidebarOpen ? "✖" : "☰"}
          </button>
        </nav>
      </header>
      <main>
        {/* Routes/content here */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dictionary" element={<Dictionary />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/about" element={<About />} />
          <Route path="/scraps" element={<Scraps />} />
          <Route path="/nodes/:id" element={<NodeDetails />} />
        </Routes>
      </main>
      <footer>
        {/* Footer content here */}
      </footer>
    </BrowserRouter>
  );
};

export default AppRoutes;